import React, { useEffect, useState } from "react";
import Clock from "../../components/clock";
import TicketNoList from "../../components/ticket/ticketNoList";
import Overlay from "../../components/overLay";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTickets } from "../../redux/slices/ticketSlice";
import { decodeJWT } from "../../utilities/jwt/decodeJWT";
import { useTranslation } from "react-i18next";
import BackdropSpinner from "../../components/backdropSpinner";
import { clearUser, fetchUserDetail } from "../../redux/slices/userSlice";
import { updateFcmTokenThunk } from "../../redux/slices/fcmTokenSlice";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../../firebase";
import toast from "react-hot-toast";
import { getTicketTimerData } from "../../redux/slices/ticketTimerSlice";
import { clearWallet, fetchWalletData } from "../../redux/slices/walletSlice";
import { logout } from "../../redux/slices/authSlice";
import { clearTickets } from "../../redux/slices/purchaseTicketsSlice";

const Tickets = () => {
  const [isFrozen, setIsFrozen] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const [showCountdown, setShowCountdown] = useState(false);
  const [isJackpot, setIsJackpot] = useState(true);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userID");
  const dispatch = useDispatch();
  const { tickets, loading } = useSelector((state) => state.tickets);
  const maxLimit = tickets[0]?.max_ticket_quantity_per_purchase || 0;
  const { timerData } = useSelector((state) => state.ticketTimer);
  const { user } = useSelector((state) => state.user);
  const userData = user?.data?.[0];

  // Handle Notification Permissions and Token
  useEffect(() => {
    const requestNotificationPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          const fcmToken = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
          });

          if (fcmToken) {
            await dispatch(
              updateFcmTokenThunk({ user_id: userId, fcm_token: fcmToken })
            ).unwrap();
          } else {
            console.log("FCM token generation failed.");
            toast.error("Please enable notifications.");
          }
        } else {
          console.log("Notification permission not granted.");
          toast.error(t("notification_error"));
        }
      } catch (error) {
        console.error("Error during notification setup:", error);
      }
    };

    if (userId) {
      requestNotificationPermission();
    }
  }, [userId, dispatch]);

  useEffect(() => {
    if (userId) {
      dispatch(fetchWalletData(userId)); // Fetch wallet data on component mount
    }
  
    if (userData && userData.is_blocked === 1) {
      localStorage.clear();
      // Dispatch the logout action
          dispatch(logout());
          dispatch(clearTickets());
          dispatch(clearWallet());
          dispatch(clearUser());
      navigate("/login")
    }
  }, [userId, dispatch, userData,navigate]);
  

  // Listen for foreground notifications
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Notification received in foreground:", payload);
      const { notification, data } = payload;

      // Display browser notification
      if (Notification.permission === "granted") {
        const notificationInstance = new Notification(notification.title, {
          body: notification.body,
          data, // Pass additional data for redirection
        });

        notificationInstance.onclick = (event) => {
          event.preventDefault();
          if (data && data.url) {
            navigate(data.url); // Redirect to the specified URL
          }
        };
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // const handleCountdownStart = () => {
  //   setShowCountdown(true);
  //   let seconds = 10;

  //   const countdownInterval = setInterval(() => {
  //     setCountdown(seconds);
  //     seconds -= 1;

  //     if (seconds < 0) {
  //       clearInterval(countdownInterval);
  //       if (isJackpot) {
  //         setIsJackpot(true);
  //       } else {
  //         navigate("/another-route");
  //       }
  //     }
  //   }, 1000);
  // };

  const handleCountdownStart = (time) => {
    setShowCountdown(true);
    setCountdown(time);
    time -= 1;
    if (time < 0) {
      if (isJackpot) {
        setIsJackpot(true);
      } else {
        navigate("/result");
      }
    }
  };

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserDetail(userId));
    }
    dispatch(getTickets());
  }, [dispatch, userId]);

  useEffect(() => {
    const is_verified = localStorage.getItem("is_verified") === "true";
    if (is_verified) {
      navigate("/"); // Navigate to home if verified
    } else {
      navigate("/set-password", { replace: true }); // Navigate to register if not verified
    }
  }, [navigate]);

  useEffect(() => {
    const fetchTicketTimerData = async () => {
      try {
        // Dispatch the action to get data
        await dispatch(getTicketTimerData()).unwrap();
      } catch (error) {
        console.error("Error fetching ticket timer data:", error);
      }
    };

    fetchTicketTimerData(); // Make the API call when the component renders
  }, [dispatch]);

  // Decode Token and Store Data
  useEffect(() => {
    if (token?.trim()) {
      const decoded = decodeJWT(token);
      localStorage.setItem("decodedData", JSON.stringify(decoded));
      if (maxLimit > 0) {
        localStorage.setItem("maxLimit", maxLimit);
      }
      const data = localStorage.getItem("decodedData");
      if (data) {
        const parsedData = JSON.parse(data);
        localStorage.setItem("userID", parsedData?.id);
      }
    }
  }, [token, maxLimit]);

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="mt-5">
        <div className="flex justify-center items-center">
          <Clock
            onFreeze={setIsFrozen}
            onCountdownStart={handleCountdownStart}
            countDownTime={timerData}
          />
        </div>
        <p className="text-white text-center text-2xl sm:text-2xl md:text-2xl lg:text-2xl my-5 ml-2">
          {t("lucky-number.luckyNumber")}
        </p>

        {isFrozen && (
          <Overlay
            countdown={countdown}
            showCountdown={showCountdown}
            isJackpot={isJackpot}
          />
        )}

        {loading ? (
          <BackdropSpinner />
        ) : (
          <TicketNoList tickets={tickets} isFrozen={isFrozen} />
        )}
      </div>
    </div>
  );
};

export default Tickets;
